import { Button } from "@mui/material"
import LoopIcon from '@mui/icons-material/Loop';

interface RefreshButtonProps {
    refresh: () => void
}

const RefreshButton: React.FC<RefreshButtonProps> = (props) => {
    return (
        <Button
            style={{paddingBottom: "0px", paddingTop: "0px"}}
            variant="text"
            color="primary"
            startIcon={<LoopIcon />}
            onClick={props.refresh}
        >
            Refresh
        </Button>
    )
}

export default RefreshButton